import script from "./PublicLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicLayout.vue?vue&type=script&setup=true&lang=js"

import "./PublicLayout.vue?vue&type=style&index=0&id=24436243&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24436243"]])

export default __exports__